import { Cubby } from "../Cubby";

export const shouldShowGetInfoButton = (cubby: Cubby) => {
  if (
    [
      "started_successfully",
      "wallet_info_available",
      "subscriptions_started",
    ].includes(cubby.runStatus)
  ) {
    return true;
  } else {
    return false;
  }
};

export const isConsideredReadyForBasicLightningApiRequests = (cubby: Cubby) => {
  return (
    cubby.litRpcIsReady &&
    cubby.allowOnchainActions &&
    cubby.cubbyInfo.data["lightning_api_ready"] == true &&
    cubby.last_recovery_attempt == null
  );
};

export const litRpcIsReady = (cubby: Cubby) => {
  if (
    cubby.runStatus === "subscriptions_started" &&
    cubby.cubbyInfo.data &&
    cubby.cubbyInfo.data["lit_tls_exists"] == true &&
    cubby.cubbyInfo.data["lit_macaroon_exists"] == true
  ) {
    return true;
  }
  return false;
};
